import styled, { css } from "styled-components";

export const Wrapper = styled.ul`
  display: flex;
  padding: 0;
  margin: 0;
  list-style-type: none;
  min-height: 45px;
`;

export const StatusCol = styled.li<{ $center?: boolean }>`
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--Neutral-200, #e5e5e5);
  padding: 0 12px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;

  ${({ $center }) =>
    $center &&
    css`
      text-align: center;
      justify-content: center;
    `}
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: max-content;
  max-width: 100%;
`;

export const Col = styled.div<{
  $active?: boolean;
  $type?: "small" | "medium" | "large";
  $isCheckbox?: boolean;
}>`
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--Neutral-200, #e5e5e5);
  color: var(--Neutral-900, #171717);
  padding: 0px 12px;
  font-size: 14px;
  font-weight: 400;
  font-family: "Inter";
  min-width: 10%;
  width: 100%;
  min-height: 50px;
  background-color: ${({ $active }) =>
    $active ? "#fff" : "#f2f5f8 !important"};
  cursor: default;

  ${({ $isCheckbox }) =>
    $isCheckbox &&
    css`
      border-left: 6px solid #1c8b7e;
    `}

  ${({ $type }) =>
    $type === "small" &&
    css`
      position: relative;
      min-width: 40px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    `}

    ${({ $type }) =>
    $type === "medium" &&
    css`
      width: 100%;
      min-width: 150px;
      max-width: 100%;
      justify-content: center;
    `}

  ${({ $type }) =>
    $type === "large" &&
    css`
      width: 100%;
      min-width: 500px;
      max-width: 100%;

      &:hover {
        .add-category {
          opacity: 1;
          visibility: visible;
        }
      }
    `}
`;

export const Status = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #404040;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  margin-left: 10px;
`;

export const Dragger = styled.span<{ $disabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: move;
  width: 100%;
  height: 100%;

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;

export const AddButton = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  height: 100%;
`;

const iconStyles = `
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  width: 20px;
  height: 20px;
  padding: 0;
`;

export const InputGroup = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  // padding: 12px 0 12px 12px;
  padding: 0 12px 0 0;
  // gap: 4px;

  &:hover {
    .action-items {
      opacity: 1;
      visibility: visible;
    }
  }
`;

export const NameContent = styled.div<{ $disabled: boolean; $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 600px;

  ${({ $disabled }) =>
    $disabled
      ? css``
      : css`
          &:hover {
            button {
              opacity: 1;
              visibility: visible;
            }
          }
        `}
`;

export const NameContainer = styled.div<{ $collapsed: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  padding: 14px 0px 14px 12px;
  cursor: default;

  ${({ $collapsed }) =>
    $collapsed &&
    css`
      padding-bottom: 14px;
    `}
`;

export const NameWrapper = styled.div`
  flex: 1;
  word-break: break-word;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100px;

  input {
    height: 100%;
    padding: 13px 12px;
    border-radius: 0;
    margin-right: 12px;
  }

  span {
    display: block;
    cursor: default;
    transition: padding-bottom 0.3s;
  }
`;

export const NoteWrapper = styled.div`
  div {
    padding: 8px 0 12px 12px;
  }
`;

export const AddNote = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: none;
  border: none;
  color: var(--primary-500-main, #1271a6);
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
  padding: 0;
`;

export const Toggle = styled.button<{ $active: boolean }>`
  ${iconStyles};
  transform: rotate(90deg);
  transition: transform 0.3s;

  ${({ $active }) =>
    $active &&
    css`
      transform: rotate(0deg);
    `}
`;

export const UpdateStatusContent = styled.div`
  padding: 12px 24px;

  h3 {
    color: #171717;
    font-weight: 400;
    font-size: 14px;
    margin: 0;
    padding: 0;
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid #edeef2;
    font-family: "Inter", sans-serif;
  }

  label {
    margin: 0;
    padding: 0;
    color: #737373;
    font-size: 14px;
    font-weight: 400;
    font-family: "Inter", sans-serif;
  }

  h4 {
    margin: 0;
    padding: 0;
    color: #171717;
    font-size: 14px;
    padding: 12px 0px;
    font-family: "Inter", sans-serif;
  }
`;

export const StatusText = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #404040;
  font-size: 14px;
  font-weight: 500;
  padding: 12px 0px;
`;

export const NewPlanProgress = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #edeef2;
  padding-top: 12px;
  margin-top: 12px;

  h2 {
    margin: 0;
    padding: 0;
    color: #737373;
    font-size: 14px;
    font-weight: 500;
  }
`;

export const UpdateStatusFooter = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  background-color: #f5f5f5;
  margin-top: 16px;

  button {
    border: 1px solid #1271a6;
    border-radius: 2px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    font-family: "Inter";
    padding: 8px 20px;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  button:nth-child(1) {
    background-color: transparent;
    color: #1271a6;
  }

  button:nth-child(2) {
    background-color: #1271a6;
    color: #fff;
  }
`;

export const ProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: max-content;

  .ant-progress {
    width: 54px;
  }

  span {
    font-size: 13px;
    font-weight: 500;
    font-family: "Inter";
  }
`;

export const StatusIconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  span {
    color: #404040;
    font-size: 14px;
    font-weight: 400;
    font-family: "Inter";
  }
`;
